import { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { Grid, InputAdornment, withWidth } from "@material-ui/core";
import {
  FilterBar,
  Container,
  DataGrid,
  Paginate,
  InputText,
  Dialog,
} from "src/components";

import {
  Close as CloseIcon,
  Visibility as VerIcon,
  List as ListarIcon,
  Lock as BlockIcon,
  LockOpen as LockOpenIcon,
} from "@material-ui/icons";

import NumberFormat from "react-number-format";
import { toUpper, abreviaNome } from "src/helpers";

import {
  carregarClientes,
  bloquearCliente,
  desbloquearCliente,
} from "src/store/actions/clientes";
import * as types from "src/store/types/clientes";
import EmpresaClienteView from "./ViewCliente";
import EmpresaClienteExtrato from "./ClienteExtrato";

function Clientes({ width }) {
  const [dialog, setDialog] = useState({
    view: false,
    list: false,
    lock: false,
  });
  const [cliente, setCliente] = useState({});

  const dispatch = useDispatch();

  const { loading, clientes, per_page, page, total, filtro } = useSelector(
    (state) => state.clientes
  );

  useEffect(() => pesquisar(), []);

  const setFiltro = (value) =>
    dispatch({ type: types.EMP_CLIENTES_SET_FILTRO, payload: { ...value } });

  const pesquisar = () => {
    dispatch(
      carregarClientes({
        ...filtro,
        per_page,
        page,
      })
    );
  };

  function limparfiltros() {
    setFiltro({ nome: "", cep: "", uf: "", cidade: "", distancia: "" });
    dispatch([
      { type: types.EMP_CLIENTES_LOADING, payload: true },
      { type: types.EMP_CLIENTES_SET_PAGE, payload: 1 },
      carregarClientes({ page: 1, per_page: 10 }),
    ]);
  }

  function handleChangePage(newPage) {
    dispatch([
      { type: types.EMP_CLIENTES_LOADING, payload: true },
      { type: types.EMP_CLIENTES_SET_PAGE, payload: newPage + 1 },
      carregarClientes({
        ...filtro,
        page: newPage + 1,
        per_page: per_page,
      }),
    ]);
  }

  const handleChangeRowsPerPage = (event) => {
    dispatch([
      { type: types.EMP_CLIENTES_LOADING, payload: true },
      {
        type: types.EMP_CLIENTES_SET_PERPAGE,
        payload: parseInt(event.target.value, 10),
      },
      carregarClientes({
        ...filtro,
        page: 1,
        per_page: parseInt(event.target.value, 10),
      }),
    ]);
  };

  function rowDistancia(rowData) {
    const unformat = (linha) => linha.replace(/[^0-9]/g, "");
    const distancia = (valor) =>
      valor > 1
        ? `${parseFloat(String(valor)).toFixed(1)} km`
        : `${parseInt(
            unformat(String(parseFloat(String(valor)).toFixed(3)))
          )} mt`;
    if (rowData.distancia !== null) {
      return <>{distancia(rowData.distancia)}</>;
    } else {
      return "";
    }
  }

  function rowMaskCPF(rowData) {
    return _.join(
      _.map(rowData.cpf_cnpj, (item, index) =>
        index > 2 && index < 8 ? "*" : item
      ),
      ""
    );
  }

  async function bloquearOuDesbloquearUsuario() {
    setDialog({ lock: false });
    if (cliente.bloqueado > 0) await desbloquearCliente(cliente.cliente_id);
    else await bloquearCliente(cliente.cliente_id);
    pesquisar();
  }

  return (
    <Container title="Listagem de clientes">
      <EmpresaClienteView
        open={dialog.view}
        close={() => setDialog({ view: false })}
        cliente={cliente}
      />
      <EmpresaClienteExtrato
        open={dialog.list}
        close={() => setDialog({ list: false })}
        cliente_id={cliente.cliente_id}
      />
      <Dialog
        visible={dialog.lock}
        title={parseInt(cliente.bloqueado) > 0 ? "Desbloquear" : "Bloquear"}
        contenttext={
          parseInt(cliente.bloqueado) > 0
            ? "Deseja realmente Desbloquear este usuário?"
            : "Deseja realmente Bloquear este usuário?"
        }
        buttons={[
          {
            title: parseInt(cliente.bloqueado) > 0 ? "Desbloquear" : "Bloquear",
            icon:
              parseInt(cliente.bloqueado) > 0 ? (
                <LockOpenIcon color="primary" />
              ) : (
                <BlockIcon color="primary" />
              ),
            onClick: () => bloquearOuDesbloquearUsuario(),
          },
          {
            title: "Fechar",
            icon: <CloseIcon />,
            onClick: () => setDialog({ lock: false }),
          },
        ]}
      />
      <FilterBar
        searchFilter={pesquisar}
        clearFilter={limparfiltros}
        title="Clique aqui para visualizar as opções de filtro."
      >
        <Grid container spacing={2}>
          <Grid item sm={4}>
            <InputText
              label="Nome do cliente"
              value={filtro.nome}
              onChange={(e) => setFiltro({ nome: e.target.value })}
            />
          </Grid>

          <Grid item sm={2}>
            <InputText
              label="CEP"
              value={filtro.cep}
              onChange={(e) => setFiltro({ cep: e.target.value })}
            />
          </Grid>
          <Grid item sm={1}>
            <InputText
              label="UF"
              value={filtro.uf}
              onChange={(e) => setFiltro({ uf: e.target.value })}
            />
          </Grid>
          <Grid item sm={3}>
            <InputText
              label="Cidade"
              value={filtro.cidade}
              onChange={(e) => setFiltro({ cidade: e.target.value })}
            />
          </Grid>
          <Grid item sm={2}>
            <InputText
              label="Distância até"
              value={filtro.distancia}
              onChange={(e) => setFiltro({ distancia: e.target.value })}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">Metros</InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </FilterBar>
      <PerfectScrollbar>
        <DataGrid
          isLoading={loading}
          columns={[
            {
              title: "ID",
              field: "cliente_id",
              width: 30,
              headerStyle: { paddingLeft: 10 },
              cellStyle: { paddingLeft: 10 },
              hidden: ["lg", "xl"].includes(width) ? false : true,
            },
            {
              title: "Nome",
              render: (data) => abreviaNome(toUpper(data.nome), 30),
              width: "auto",
              headerStyle: { paddingLeft: 10 },
              cellStyle: { paddingLeft: 10 },
            },
            {
              title: "Documento",
              render: (data) => rowMaskCPF(data),
              width: 150,
              headerStyle: {},
              cellStyle: {},
            },
            {
              title: "CEP",
              render: (data) => data.cep,
              width: 90,
              headerStyle: {},
              cellStyle: {},
              hidden: ["xl"].includes(width) ? false : true,
            },
            {
              title: "Bairro",
              render: (data) => toUpper(data.bairro),
              width: 160,
              headerStyle: {},
              cellStyle: {},
              hidden: ["xl"].includes(width) ? false : true,
            },
            {
              title: "Cidade",
              render: (data) => toUpper(data.cidade),
              width: 160,
              headerStyle: {},
              cellStyle: {},
              hidden: ["lg", "xl"].includes(width) ? false : true,
            },
            {
              title: "UF",
              render: (data) => toUpper(data.uf),
              width: 30,
              headerStyle: {},
              cellStyle: {},
            },
            {
              title: "Distancia",
              field: "distancia",
              render: (data) => rowDistancia(data),
              width: 30,
              headerStyle: {},
              cellStyle: {},
            },
            {
              title: "Saldo",
              field: "saldo_cashback",
              render: (data) => (
                <NumberFormat
                  decimalScale={2}
                  fixedDecimalScale={true}
                  prefix={"R$ "}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  displayType={"text"}
                  value={data.saldo_cashback || 0}
                />
              ),
              width: 30,
              headerStyle: {},
              cellStyle: { textAlign: "center" },
            },
          ]}
          data={clientes}
          options={{
            sorting: true,
          }}
          actions={[
            {
              icon: () => <VerIcon color="primary" />,
              tooltip: "Visualizar",
              onClick: (event, rowData) => {
                setCliente(rowData);
                setDialog({ view: true });
              },
            },
            {
              icon: () => <ListarIcon color="primary" />,
              tooltip: "Extrato",
              onClick: (event, rowData) => {
                setCliente(rowData);
                setDialog({ list: true });
              },
            },
            (rowData) => ({
              icon: () =>
                parseInt(rowData.bloqueado) > 0 ? (
                  <BlockIcon style={{ color: "red" }} />
                ) : (
                  <LockOpenIcon color="primary" />
                ),
              tooltip:
                parseInt(rowData.bloqueado) > 0 ? "Desbloquear" : "Bloquear",
              onClick: (event, rowData) => {
                setCliente(rowData);
                setDialog({ lock: true });
              },
            }),
          ]}
        />
      </PerfectScrollbar>
      <Paginate
        rowsPerPageOptions={[10, 25, 50]}
        rowsPerPage={parseInt(per_page)}
        count={total}
        page={page - 1}
        onChangePage={(event, newPage) => handleChangePage(newPage)}
        onChangeRowsPerPage={(e) => handleChangeRowsPerPage(e)}
      />
    </Container>
  );
}

export default withWidth()(Clientes);
